import React from 'react';

import { Route } from 'helpers/routes/routes';
import { CommonPageData, socThemeScreensUrl } from 'helpers/routes/CommonPageData';

export enum DocumentsRoute {
  DocumentList = '/documents',
  DocumentFilter = '/documentsSearch/filter',
  DocumentDetail = '/documents/:objectStoreName/:documentGUID',
  SendingCreation = '/documents/sendingCreation',
  DocumentSending = '/documents/document-sending',
  DocumentSendingDeeplink = '/documents/document-sending/:journalJobPk',
  DocumentsForConfirmation = '/documents/confirmations',
}

const defaultCommonPageData: CommonPageData = {
  pageTitle: 'onecrm.common.pageTitle.documents',
  visibleForAnonym: false,
};

export const DocumentsRoutes: Route[] = [
  {
    path: DocumentsRoute.DocumentList,
    exact: true,
    component: React.lazy(() => import('views/pages/DocumentList/DocumentList')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.30.1',
      templateUrl: socThemeScreensUrl('2-30-1-seznam-dokumentu.html'),
    },
  },
  {
    path: DocumentsRoute.DocumentFilter,
    exact: true,
    isInternal: true,
    component: React.lazy(() => import('views/pages/DocumentFilter/DocumentFilter')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.30.5',
      templateUrl: socThemeScreensUrl('2-30-5-nacitani-kontaktnich-osob-zakaznika.html'),
    },
  },
  {
    path: DocumentsRoute.DocumentSendingDeeplink,
    exact: true,
    isInternal: true,
    component: React.lazy(() => import('views/pages/DocumentSending/DocumentSending')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.30.4',
      templateUrl: socThemeScreensUrl('2-30-4-nahled-dokumentu.html'),
    },
  },
  {
    path: DocumentsRoute.DocumentDetail,
    exact: true,
    component: React.lazy(() => import('views/pages/DocumentDetail/DocumentDetail')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.30.2',
      templateUrl: socThemeScreensUrl('2-30-2-detail-dokumentu.html'),
    },
  },
  {
    path: DocumentsRoute.SendingCreation,
    exact: true,
    isInternal: true,
    component: React.lazy(() => import('views/pages/SendingCreation/SendingCreation')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.30.3',
      templateUrl: socThemeScreensUrl('2-30-3-vytvoreni-zasilky.html'),
    },
  },
  {
    path: DocumentsRoute.DocumentSending,
    exact: true,
    isInternal: true,
    component: React.lazy(() => import('views/pages/DocumentSending/DocumentSending')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.30.4',
      templateUrl: socThemeScreensUrl('2-30-4-nahled-dokumentu.html'),
    },
  },
  {
    path: DocumentsRoute.DocumentsForConfirmation,
    exact: true,
    component: React.lazy(() => import('views/pages/DocumentsForConfirmation/DocumentsForConfirmation')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.30.7',
      templateUrl: socThemeScreensUrl('2-30-7-dokumenty-ke-schvaleni.html'),
    },
  },
];
